import { render, staticRenderFns } from "./NewLeadIcon.vue?vue&type=template&id=46370dc2&scoped=true&"
import script from "./NewLeadIcon.vue?vue&type=script&lang=js&"
export * from "./NewLeadIcon.vue?vue&type=script&lang=js&"
import style0 from "./NewLeadIcon.vue?vue&type=style&index=0&id=46370dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46370dc2",
  null
  
)

export default component.exports